import { Icon } from '@/core/components'
import styles from './styles.module.css'
import safeGuido from '@/assets/images/full_logo.png'

interface IProps {
    closeChat: () => void
}
export const HeaderChat = ({ closeChat }: IProps) => {
    return (
        <div className={styles.container}>
            <img src={safeGuido} className={styles.logo} />
            <Icon name='x' size={24} color='#717375' onClick={closeChat} />
        </div>
    )
}
